/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Doc_Classification_Explanation_LabelInputs */

const en_doc_classification_explanation_label = /** @type {(inputs: Doc_Classification_Explanation_LabelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Analysis`)
};

const pt_br2_doc_classification_explanation_label = /** @type {(inputs: Doc_Classification_Explanation_LabelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Análise`)
};

/**
* | output |
* | --- |
* | "Analysis" |
*
* @param {Doc_Classification_Explanation_LabelInputs} inputs
* @param {{ locale?: "en" | "pt-BR" }} options
* @returns {LocalizedString}
*/
export const doc_classification_explanation_label = /** @type {((inputs?: Doc_Classification_Explanation_LabelInputs, options?: { locale?: "en" | "pt-BR" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Doc_Classification_Explanation_LabelInputs, { locale?: "en" | "pt-BR" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_doc_classification_explanation_label(inputs)
	return pt_br2_doc_classification_explanation_label(inputs)
});